var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("keep-alive", [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal_size sm_size" }, [
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "JavaScript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content" }, [
            _c("dt", { staticClass: "ellipsis" }, [
              _c("i", [
                _vm._v(_vm._s(_vm.$t("TITLE.CODEMNG.DETAIL.CODE.INFORMATION")))
              ])
            ]),
            _vm._v(" "),
            _c("dd", [
              _c("table", { staticClass: "create_table" }, [
                _c("colgroup", [
                  _c("col", { attrs: { width: "32%" } }),
                  _vm._v(" "),
                  _c("col", { attrs: { width: "*" } })
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.CODEMNG.CODE"))),
                      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "clearable" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.codeId,
                              expression: "codeId"
                            },
                            { name: "clearable", rawName: "v-clearable" }
                          ],
                          ref: "codeId",
                          staticClass: "text_input w100",
                          attrs: {
                            type: "text",
                            disabled: _vm.viewMode,
                            maxlength: "30"
                          },
                          domProps: { value: _vm.codeId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.codeId = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "clearable_clear" }, [
                          _vm._v("X")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.CODEMNG.CODE.NAME")))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "clearable" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.codeName,
                              expression: "codeName"
                            },
                            { name: "clearable", rawName: "v-clearable" }
                          ],
                          staticClass: "text_input w100",
                          attrs: { type: "text", maxlength: "1000" },
                          domProps: { value: _vm.codeName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.codeName = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "clearable_clear" }, [
                          _vm._v("X")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("FIELD.CODEMNG.UPPER.CODE")))
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { "data-input-type": "select" } }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.upperCode,
                              expression: "upperCode"
                            }
                          ],
                          staticClass: "slt_white w100p",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.upperCode = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", selected: "" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.CODEMNG.UPPER.CODE")))
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ORDER")))]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", { staticClass: "clearable" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order,
                              expression: "order"
                            },
                            { name: "clearable", rawName: "v-clearable" }
                          ],
                          staticClass: "text_input w100",
                          attrs: { type: "text" },
                          domProps: { value: _vm.order },
                          on: {
                            keyup: function($event) {
                              return _vm.onlyNumber($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.order = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "clearable_clear" }, [
                          _vm._v("X")
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.STATUS")))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status,
                              expression: "status"
                            }
                          ],
                          staticClass: "slt_white w100p",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.status = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", selected: "" } }, [
                            _vm._v("Status")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "A" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ACTIVE")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "S" } }, [
                            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SLEEP")))
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn_modal_wrap topLine" }, [
                _c("div", { staticClass: "btn_right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn_blue",
                      attrs: { href: "JavaScript:" },
                      on: {
                        click: function($event) {
                          return _vm.detlCodeSave()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4495ef98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4495ef98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/system/code/CodeDetlPopup.vue
// module id = mWl6
// module chunks = 0